export enum ECourseType {
  INHOUSE = 'inhouse',
  HYBRID = 'hybrid',
  ONLINE = 'online',
  NONE = 'none',
}
